<template>
    <div class="spec">
        <el-dialog title="商品规格" :visible.sync="dialogVisible" width="576px" :before-close="handleClose">
            <div v-if="rowData" class="content">
                <el-checkbox-group v-model="specIdList" size="small" @change="selChange">
                    <el-checkbox v-for="(item, index) in rowData.spec_list" :key="index" :label="item.title" border size="medium" :disabled="item.merchandise_inventory == 0"></el-checkbox>
                </el-checkbox-group>
            </div>
            <el-empty description="暂无内容!" v-else></el-empty>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeDia">取 消</el-button>
                <el-button type="primary" @click="confirmDia">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            specIdList: [],
            rowData: null,
            dialogVisible: false,
            id_list: [],
        };
    },
    methods: {
        // 绑定规格数据
        BindData(row) {
            this.rowData = row;
            if (this.rowData.spec_list && this.rowData.spec_list.length > 0 && this.rowData.id_list && this.rowData.id_list.length > 0) {
                this.rowData.spec_list.forEach((item) => {
                    this.rowData.id_list.forEach((v) => {
                        if (item.id == v.id) {
                            this.specIdList.push(item.title);
                        }
                    });
                });
            }
        },
        // 选择规格改变
        selChange() {
            this.id_list = [];
            if (this.rowData.spec_list && this.rowData.spec_list.length != 0) {
                this.rowData.spec_list.forEach((item) => {
                    this.specIdList.forEach((v) => {
                        if (item.title == v) {
                            let o = {
                                id: item.id,
                                title: item.title,
                                merchandise_inventory: item.merchandise_inventory,
                            };
                            this.id_list.push(o);
                        }
                    });
                });
            }
        },
        // 确认规格选择
        confirmDia() {
            this.specIdList = [];
            this.$emit("rowAddList", this.id_list);
            this.dialogVisible = false;
        },
        // 取消
        closeDia() {
            this.dialogVisible = false;
            this.specIdList = [];
        },
        // 关闭弹窗
        handleClose() {
            this.dialogVisible = false;
            this.specIdList = [];
        },
    },
};
</script>

<style lang="scss" scoped>
.content {
    min-height: 200px;
    ::v-deep .el-checkbox.is-bordered {
        margin-left: 0;
        margin-bottom: 14px;
    }
}
</style>